import { useContext } from "react";
import { DragSourceMonitor, useDrag } from "react-dnd";
import { FormActionContext } from "..";
import { ItemTypes, APP_PART_TYPES } from "../constants";
import { TagItemProps, AppPartType } from "../types";
import { getGroupType } from "../../utils";

const TagItem = ({ tag, onDragStart, onDragEnd, style }: TagItemProps) => {
  const { disabled, icon, name, group_type } = tag;
  const { contextState, setContextState, onHandleAddItemToParentItem } =
    useContext(FormActionContext);
  const [{ isDragging }, drag] = useDrag({
    // only Text TAG is allow to be inside Table
    type: ItemTypes.BOX,
    item: tag,
    end: (item, monitor: any) => {
      const dropResult: AppPartType = monitor.getDropResult();
      if (item && dropResult && contextState.isHoverParentItem) {
        setContextState((draft) => {
          draft.isHoverParentItem = false;
          draft.resetLayout = false;
        });
        // This an work around for fixing the shadow bug remaining on the board when add item to table
        setTimeout(() => {
          setContextState((draft) => {
            draft.resetLayout = true;
          });
        }, 0);
        // Adding Item into Table
        onHandleAddItemToParentItem(
          tag /* newItem */,
          dropResult.item_config_data.i /* parentI */,
        );
      }
    },
    collect: (monitor: DragSourceMonitor<AppPartType, unknown>) => ({
      // only Text TAG is allow to be inside Table
      isDragging:
        APP_PART_TYPES.TEXT === tag.app_part_type
          ? monitor.isDragging()
          : false,
      handlerId: monitor.getHandlerId(),
    }),
  });

  const dataGroupType = getGroupType(group_type);
  return (
    <div
      draggable={!disabled}
      // this is a hack for firefox
      // Firefox requires some kind of initialization
      // which we can do by adding this attribute
      // @see https://bugzilla.mozilla.org/show_bug.cgi?id=568313
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      style={{
        opacity: isDragging ? 0.4 : 1,
        margin: "0 5px 5px 5px",
      }}
      ref={!disabled ? drag : null}
    >
      <div
        className={`btn-drag ${disabled ? "disabled" : ""}`}
        style={{
          background: dataGroupType.bgColor,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "2px",
            ...style,
          }}
        >
          {icon ? icon : null}
          {name}
        </div>
      </div>
    </div>
  );
};

export default TagItem;
